module.exports = __webpack_public_path__ + "img/activity.94c9f545.svg";